var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonShareSocialOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36255 13.6123C6.50164 13.6123 7.42505 12.6889 7.42505 11.5498C7.42505 10.4107 6.50164 9.4873 5.36255 9.4873C4.22346 9.4873 3.30005 10.4107 3.30005 11.5498C3.30005 12.6889 4.22346 13.6123 5.36255 13.6123Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3625 7.4248C17.5016 7.4248 18.425 6.50139 18.425 5.3623C18.425 4.22322 17.5016 3.2998 16.3625 3.2998C15.2235 3.2998 14.3 4.22322 14.3 5.3623C14.3 6.50139 15.2235 7.4248 16.3625 7.4248Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3625 19.7998C17.5016 19.7998 18.425 18.8764 18.425 17.7373C18.425 16.5982 17.5016 15.6748 16.3625 15.6748C15.2235 15.6748 14.3 16.5982 14.3 17.7373C14.3 18.8764 15.2235 19.7998 16.3625 19.7998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15991 12.5605L14.5651 16.7259M14.5651 6.37305L7.15991 10.5384",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonShareSocialOutline);
export default __webpack_public_path__ + "static/media/ion_share-social-outline.722dc26c3292d39d33201322c80fdae5.svg";
export { ForwardRef as ReactComponent };